import { render, staticRenderFns } from "./OfferGoodsForm.vue?vue&type=template&id=0d9a5c83&scoped=true"
import script from "./OfferGoodsForm.vue?vue&type=script&lang=js"
export * from "./OfferGoodsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d9a5c83",
  null
  
)

export default component.exports